module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    attrs: {
      "name": "delivery-address",
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.sameInvoiceAddress
    },
    on: {
      "change": _vm.updateSameInvoiceAddress
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "custom-checkbox"
  }), _vm._v("\n        Rechnungsadresse gleich wie Lieferadresse\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c56ef4c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/Forms/Fields/SameInvoiceAddress.vue
// module id = 844
// module chunks = 0